import { FunctionComponent } from 'react'

import {
  AddressFormatter,
  BooleanFormatter,
  BooleanListFormatter,
  CascadingDropdownFormatter,
  CheckboxEligibilityFormatter,
  CheckboxListFormatter,
  DateFormatter,
  InputLoopFormatter,
  LookupFormatter,
  MonthsRangeFormatter,
  NameFormatter,
  NumberTextFormatter,
  RadioFormatter,
  SingleSelectFormatter,
  StringFormatter,
  VehicleFormatter,
  VehicleRegistrationFormatter,
  YearMonthFormatter,
} from './formatters'
import {
  AddressFormInput,
  BooleanFormInput,
  BooleanListFormInput,
  CascadingFormInput,
  CheckboxEligibilityFormInput,
  CheckboxFormInput,
  CheckboxListFormInput,
  CheckboxPromotionFormInput,
  DataEntryInput,
  DateFormInput,
  DatePickerFormInput,
  DropDownSelectFormInput,
  EmailFormInput,
  HiddenFormInput,
  LookupFormInput,
  MonthsRangeFormInput,
  NameFormInput,
  NumberTextFormInput,
  PhoneNumberFormInput,
  RadioFormInput,
  SingleSelectFormInput,
  TextFormInput,
  VehicleLookupFormInput,
  VehicleRegistrationFormInput,
  VehicleTabsFormInput,
  YearMonthFormInput,
} from './inputs'
import { Formatter, FormInputProps } from './types'

const inputMap: Record<string, FunctionComponent<FormInputProps>> = {
  boolean: BooleanFormInput,
  booleanList: BooleanListFormInput,
  name: NameFormInput,
  date: DateFormInput,
  lookup: LookupFormInput,
  dataEntry: DataEntryInput,
  dropDownSelect: DropDownSelectFormInput,
  cascading: CascadingFormInput,
  address: AddressFormInput,
  checkbox: CheckboxFormInput,
  checkboxEligibility: CheckboxEligibilityFormInput,
  checkboxPromotion: CheckboxPromotionFormInput,
  checkboxList: CheckboxListFormInput,
  text: TextFormInput,
  radio: RadioFormInput,
  numberText: NumberTextFormInput,
  phoneNumber: PhoneNumberFormInput,
  singleSelect: SingleSelectFormInput,
  yearMonth: YearMonthFormInput,
  vehicleTabs: VehicleTabsFormInput,
  vehicleLookup: VehicleLookupFormInput,
  vehicleRegistration: VehicleRegistrationFormInput,
  datePicker: DatePickerFormInput,
  email: EmailFormInput,
  hidden: HiddenFormInput,
  monthsRange: MonthsRangeFormInput,
}

export const getInput = (
  type: keyof typeof inputMap,
): FunctionComponent<FormInputProps> => inputMap[type]

const formatterMap: Record<string, FunctionComponent<Formatter>> = {
  boolean: BooleanFormatter,
  booleanList: BooleanListFormatter,
  name: NameFormatter,
  date: DateFormatter,
  lookup: LookupFormatter,
  dataEntry: StringFormatter,
  dropDownSelect: StringFormatter,
  cascading: CascadingDropdownFormatter,
  address: AddressFormatter,
  checkboxList: CheckboxListFormatter,
  text: StringFormatter,
  radio: RadioFormatter,
  numberText: NumberTextFormatter,
  phoneNumber: StringFormatter,
  singleSelect: SingleSelectFormatter,
  yearMonth: YearMonthFormatter,
  vehicleTabs: VehicleFormatter,
  vehicleLookup: VehicleFormatter,
  vehicleRegistration: VehicleRegistrationFormatter,
  datePicker: DateFormatter,
  email: StringFormatter,
  inputLoop: InputLoopFormatter,
  monthsRange: MonthsRangeFormatter,
  checkboxEligibility: CheckboxEligibilityFormatter,
}

export const getFormatter = (
  type: keyof typeof formatterMap,
): FunctionComponent<Formatter> => {
  const formatter = formatterMap[type]

  if (!formatter) {
    throw new Error(`Could not find formatter for ${type}`)
  }

  return formatter
}
